import { useEffect } from 'react'

import {
  TASK_FORM_TITLE_FIELD_NAME,
  TASK_FORM_TYPE_FIELD_NAME,
} from '../../../TaskForm.constants'

export function useTypeFieldSuccessLoad(items, onSetInitialValues) {
  useEffect(() => {
    if (items?.length > 0) {
      onSetInitialValues(prevInitialValues => {
        if (prevInitialValues[TASK_FORM_TYPE_FIELD_NAME]) {
          return prevInitialValues
        }

        return {
          ...prevInitialValues,
          [TASK_FORM_TITLE_FIELD_NAME]: items[0]?.name,
          [TASK_FORM_TYPE_FIELD_NAME]: items[0],
        }
      })
    }
  }, [items])
}
